import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { InfoUserDataService } from '../_core/services/info-user-data.service';
import { LocalstorageService } from '../_core/services/localstorage.service';


export function initializer(keycloak: KeycloakService, http: HttpClient,infoUserDataService : InfoUserDataService,localStorageService:LocalstorageService, router:Router): () => Promise<any> {
  return async () => {
    try {
      // Initialiser Keycloak
      await keycloak.init({
        config: {
          url: environment.keycloak.url,
          realm: environment.keycloak.realm,
          clientId: environment.keycloak.clientId,
          
        },
        initOptions: {
          onLoad: 'login-required',
          checkLoginIframe: false,
        },
        enableBearerInterceptor: true,
      });

      // Vérifier si le jeton est valide ou s'il a expiré
      const isTokenValid = await keycloak.getToken() && !keycloak.isTokenExpired();

      if (!isTokenValid) {
        // Rediriger vers la page de connexion Keycloak
        keycloak.login();
      } else {
        router.navigate(["main"])
        localStorageService.removeItem('infoUser')
        if (keycloak.getKeycloakInstance()) {
          // Appeler storeUserInfo uniquement lorsque Keycloak est pleinement initialisé
          storeUserInfo(http, keycloak).subscribe(res=>{
             if(res.errorCode === "200"){
              //localStorageService.setItem(JSON.stringify(res));
              localStorageService.setItem("infoUser",res);
              infoUserDataService.updateData(res);
             }else{
              localStorageService.removeItem('infoUser')
              keycloak.logout()
             }
          });
        } else {
          console.error('Erreur lors de l\'initialisation de Keycloak.');
        }
      }
    } catch (error) {
      console.error('Error initializing Keycloak:', error);
    }
  };
}



function storeUserInfo(http: HttpClient, keycloak: KeycloakService): Observable<any> {
  const token = keycloak.getKeycloakInstance().token;
  return http.get<any>(environment.baseUrl+ "/get_info_user",{
    headers: new HttpHeaders({
      'Authorization': `Bearer ${token}`
    })
  })
}